import React, { useContext } from 'react';
import { func } from 'prop-types';
import { Carousel } from '@thd-olt-component-react/carousel';
import { Price } from '@thd-olt-component-react/price';
import { Image } from '@thd-olt-component-react/image';
import { DrawerNav, useDrawer } from '@thd-olt-component-react/drawer';
import { Sharebelt, ShareFavorite } from '@thd-olt-component-react/thd-sharebelt';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { useStoreId } from '@thd-nucleus/experience-context';
import './QuickViewDetails.scss';
import { sanitizeImageUrl } from '../../utils/QuickViewUtils';
import { QuickViewRatings } from '../quick-view-ratings/QuickViewRatings';
import { QuickViewMore } from './QuickViewMore';
import { QuickViewFooter } from './QuickViewFooter';
import { QuickViewContext } from '../../utils/QuickViewProvider';

export const QuickViewDetails = ({
  setLoadRatingsnReviews
}) => {
  const { product } = useContext(QuickViewContext);
  const storeId = useStoreId();
  const { setCurrentDrawer } = useDrawer();

  const brand = product?.identifiers?.brandName;
  const label = product?.identifiers?.productLabel;
  const canonicalUrl = product?.identifiers?.canonicalUrl;
  const images = product?.media?.images;
  const itemId = product?.itemId;

  return (
    <section className="quickview-details">
      <DrawerNav>
        <div className="quickview-details__desc">
          <h1 className="u__bold">{brand}</h1>
          <p>{label}</p>
          <QuickViewRatings />
          {product && (
            <Sharebelt itemId={itemId}>
              <ShareFavorite showCircle showFavoritesCount />
            </Sharebelt>
          )}
        </div>
      </DrawerNav>
      {images.length > 0 && (
        <div className="quickview-details-carousel">
          <Carousel
            showArrows
            dotBelow
            showDots
            multiItem={false}
          >
            {images.map((image, i) => (
              <div
                className="quickview-details-carousel__image-wrapper"
                key={`quickview-details-carousel-image-${i}`}
              >
                <Image
                  alt={image.type}
                  src={sanitizeImageUrl(image.url)}
                  lazy
                  width={1}
                  height={1}
                />
              </div>
            ))}
          </Carousel>
        </div>
      )}
      <Price
        itemId={itemId}
        storeId={storeId}
      />
      <div className="quickview-details__kpf">
        <KeyProductFeatures
          hideImage
          itemId={itemId}
          storeId={storeId}
          maxfeatures={4}
          twoColumnGrid
        />
      </div>
      <div className="quickview-details__other">
        <QuickViewMore
          title="Product Overview"
          onClick={() => setCurrentDrawer('quick-view-product-overview')}
        />
        <QuickViewMore
          title="Specifications"
          onClick={() => setCurrentDrawer('quick-view-product-specs')}
        />
        <QuickViewMore
          onClick={() => setCurrentDrawer('quick-view-product-reviews')}
        >
          <div
            className="quickview-details__other-ratings"
            onMouseEnter={() => setLoadRatingsnReviews(true)}
          >
            <h3>Ratings</h3>
            <QuickViewRatings />
          </div>
        </QuickViewMore>
        <QuickViewFooter url={canonicalUrl} />
      </div>
    </section>
  );
};

QuickViewDetails.displayName = 'QuickViewDetails';

QuickViewDetails.propTypes = {
  setLoadRatingsnReviews: func.isRequired
};